<template>
  <div class="zbList" @click="handleDetial(data.liveId)">
	<img class="zbList-img" :src="data.backgroundUrl" alt="" />
	<div class="zbList-box">
		<div class="zbList-box-fl-box">
			<div class="zbList-box-fl">{{data.categoryName}}</div>
		</div>
		<div class="zbList-box-zbjl" v-if="type == 1">
			<div class="zbList-box-zbjl-top">
				<span class="zbList-box-zbjl-left-span">{{data.name}}</span>
				<div class="zbList-box-zbjl-right" v-if="data.isOpenReplay == 1 && data.replayUrl" @click.stop="handlePlayVideo(data.replayUrl)">
					<img src="../../assets/image/huifang@2x.png" alt=""/>
					<span>{{$t('all.huifang')}}</span>
				</div>
			</div>
			<span class="zbList-box-zbjl-left-span1">{{data.liveStartTime}}-{{data.liveEndTime}}</span>
		</div>
		<div class="zbList-box-title" v-else>
			<div class="zbList-box-title-left">{{data.name}}</div>
			<div class="zbList-box-title-right">
				<img src="../../assets/image/zhibo_shutiao_16@2x.png" alt=""/>
				<span>{{data.onlineUserCount}}</span>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  name:'zbList',
  props:['data','type'],
  data() {
    return {
	  
    };
  },
  mounted() {
	
  },
  methods: {
	//跳转直播间
	handleDetial(liveId){
		if(this.type == 1){
			return
		}
		this.$router.push({ path: '/zhibojian',query:{liveId:liveId}});
	},
	handlePlayVideo(replayUrl) {
	  this.closeWindow(); // 关闭可能已存在的旧窗口
	
	  // 构造目标页面的路由
	  const routeData = this.$router.resolve({
		name: 'bofangshipin', // 目标路由的 name
		query: { url: replayUrl } // 将回放URL作为参数传递
	  });
	
	  // 使用 window.open 打开新标签页
	  this.newWindow = window.open(routeData.href, '_blank');
	
	  if (!this.newWindow) {
		// 如果 window.open 返回 null 或 undefined，说明被浏览器拦截
		this.$message.warning('弹出窗口被阻止，请允许弹出窗口后重试。');
		return;
	  }
	
	  // 监听新窗口的加载事件
	  // 这是关键：必须等待新窗口的 DOM 加载完成后，才能对其执行全屏操作
	  this.newWindow.onload = () => {
		try {
		  // 在新窗口的上下文中执行全屏函数
		  // newWindow.document.documentElement 指的是新窗口的根元素
		  enterFullscreen(this.newWindow.document.documentElement);
		} catch (e) {
		  // 全屏请求可能会失败（例如，用户在其他标签页，或浏览器策略限制）
		  console.warn("无法自动进入全屏模式，请用户手动按 F11 或使用浏览器菜单进入全屏。", e);
		  // 可以在新窗口页面上提供一个按钮，让用户手动触发全屏
		}
	  };
	},
	
	// 3. 修正后的关闭窗口方法
	closeWindow() {
	  if (this.newWindow && !this.newWindow.closed) {
		this.newWindow.close(); // 关闭新窗口
	  }
	  this.newWindow = null; // 关键：清空对已关闭窗口的引用
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./zbList.css";
</style>


// WEBPACK FOOTER //
// zbList.vue?1cec176e